import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const marques = [
  { name: "Nice", desc: "Motorisation et points de commande" },
  { name: "Simu", desc: "Moteurs tubulaires et accessoires" },
  { name: "Bubendorff", desc: "Moteurs radio et commandes" },
  { name: "Profalux", desc: "Moteurs et groupes de commande" },
  { name: "Elero", desc: "Motorisation radio et filaire" },
  { name: "Selve", desc: "Moteurs tubulaires et commandes" },
];

export default function AutresMarques() {
  return (
    <section className="bg-[#F4F8FB] py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="relative rounded-xl overflow-hidden border border-[#E2E8F0]">
            <ImagePlaceholder
              src="https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/d0e4bdbfabe020d784bb96220c210e18.jpeg"
              alt="Technicien intervenant sur différentes marques de moteurs de volet roulant à Strasbourg"
              className="w-full h-[340px] md:h-[420px]"
              loading="lazy"
            />
          </div>
          <div>
            <h2 className="text-[#143A66] text-2xl md:text-3xl font-extrabold mb-5">
              Les autres marques que nous traitons
            </h2>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-5">
              Somfy est le leader mondial des motorisations de volet roulant, mais il n'est pas le seul fabricant que nous rencontrons dans le Bas-Rhin. Nice, Simu, Bubendorff et Profalux équipent des milliers de logements dans la région. Nos techniciens sont formés aux protocoles radio de chaque marque : io et RTS pour Somfy, OXIBD pour Nice, radio propriétaire pour Bubendorff, fils conducteurs pour Profalux. Cette polyvalence nous permet de remplacer n'importe quel moteur, même si vous ne connaissez pas la marque exacte.
            </p>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-6">
              Nous intervenons fréquemment sur des logements où plusieurs marques coexistent. Un propriétaire peut avoir des volets Somfy à l'avant et des Nice à l'arrière, par exemple. Dans ce cas, nous proposons soit de conserver les commandes existantes de chaque marque, soit d'homogénéiser l'ensemble avec un système de commande universel. Notre stock de pièces couvre les moteurs tubulaires, les récepteurs, les télécommandes et les condensateurs des principales marques.
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-8">
              {marques.map((marque) => (
                <div
                  key={marque.name}
                  className="bg-white rounded-xl border border-[#E2E8F0] p-4 md:p-5 text-center hover:border-[#00B3A4]/40 transition-colors"
                >
                  <p className="text-[#143A66] font-bold text-base mb-1">{marque.name}</p>
                  <p className="text-[#2F4A63] text-xs">{marque.desc}</p>
                </div>
              ))}
            </div>
            <a
              href="tel:0374473240"
              className="flex items-center gap-2 bg-[#00B3A4] text-white px-6 py-4 rounded-lg font-semibold text-base hover:bg-[#00B3A4]/90 transition-colors whitespace-nowrap mx-auto"
            >
              <i className="ri-phone-line text-lg"></i>
              Appeler le 03 74 47 32 40
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}